/**
 * Show/hide Template feature
 * Clean-up: ORB-1028, ORB-1029
 */
const isTemplateEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TEMPLATE_ENABLED === "true";

/**
 * Show/hide Draw Polygon feature
 * Clean-up: ORB-1150, ORB-1065
 */
const isDrawPolygonEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_DRAW_POLYGON_ENABLED === "true";

/**
 * Use New Dataset Explorer Modal feature
 * Clean-up: ORB-1390, ORB-1392
 */
const isUseNewDatasetExplorerModal =
  import.meta.env.VITE_FEATURE_FLAG_IS_USE_NEW_DATASET_EXPLORER_MODAL ===
  "true";

/**
 * Show/hide Analysis Job List feature
 * Clean-up: ORB-1460
 */
const isAnalysisJobListEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_JOB_LIST_ENABLED === "true";

/**
 * Show/hide POI Info feature
 * Clean-up: TBD
 */
const isPOIInfoEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_POI_INFO_ENABLED === "true";

/**
 * Enable login with SSO
 * Clean-up: TBD
 */
const isLoginWithSsoEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_LOGIN_WITH_SSO_ENABLED === "true";

/**
 * Updated UI dataset
 * Clean-up: TBD
 */

const isNewUIDatasetConfigEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_DATASET_CONFIG_ENABLED === "true";

const isRankingLabelEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_RANKING_LABEL_ENABLED === "true";

/*
 * Enable refactor Add Dataset flow
 * Clean-up: TBD
 */
const isRefactorAddDatasetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_REFACTOR_ADD_DATASET === "true";

/*
 * Show/hide Filter Search Table Dataset with Multiple Search and Map on View or Single Search feature
 * Clean-up: ORB-1934 / ORB-1625
 */
const isMultipleSearchTableDataset =
  import.meta.env.VITE_FEATURE_FLAG_IS_MUTIPLE_SEARCH_TABLE_DATASET_ENABLED ===
  "true";

/**
 * Expose every numeric attribute of a POI dataset as an independently weighted
 * scoring component, alongside the existing Total POI Count.
 * Clean-up: TBD
 */
const isPoiNumericAttributesEnabled =
  import.meta.env.VITE_FEATURE_FLAG_ISPOINUMERICATTRIBUTES_ENABLED === "true";

/**
 * Allow a user to be assigned to several user groups at once.
 * Clean-up: TBD
 */
const isMultipleUserGroupAssignmentEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_MULTIPLE_USERGROUP_ASSIGNMENT_ENABLED ===
  "true";

/**
 * Plan-based module access (Contact Sales) and permission-denied toasts per action.
 * Clean-up: TBD
 */
const isGranularRbacEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GRANULAR_RBAC_ENABLED === "true";

/**
 * Show/hide include_scoring toggle on Data Weight Settings V2 panel
 * Clean-up: TBD
 */
const isAttributeWeightToggleEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ATTRIBUTE_WEIGHT_TOGGLE_ENABLED ===
  "true";

/**
 * Show/hide the advanced Data Weight options (simple/advanced toggle, advanced
 * full mode with Intercept, Mean/Stdv, scoring formula dropdown). When off, the
 * Data Weight panel falls back to the original single-panel UI.
 * Clean-up: TBD
 */
const isAdvanceDataWeightOptionsEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ADVANCE_DATA_WEIGHT_OPTIONS_ENABLED ===
  "true";

const isRowDatasetManagementEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ROW_DATASET_MANAGEMENT_ENABLED ===
  "true";

/**
 * Show/hide Section Global Filter on Analysis Popup
 * Clean-up: ORB-1909
 */
const isGlobalFilterEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GLOBAL_FILTER_ENABLED === "true";

/**
 * Show/hide Admin Tree Hierarchy feature in Input Area
 * Clean-up: ORB-1910
 */
const isAdminTreeEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ADMIN_TREE_ENABLED === "true";

/**
 * Analysis History Page
 * Clean-up: ORB-2010
 */
const isAnalysisHistoryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_HISTORY_ENABLED === "true";

/**
 * Analysis AI Summary feature
 * Clean-up: ORB-2164
 */
const isAISummaryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_AI_SUMMARY_ENABLED === "true";

const isLinestringEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_LINESTRING_ENABLED === "true";

/**
 * Tabular View with filter for Analysis Result on Feature Info Popup
 */
const isTabularViewAnalysisResultEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TABULAR_VIEW_ANALYSIS_RESULT_ENABLED ===
  "true";

/**
 * Analysis AI Conversation Summary feature
 * Clean-up: ORB-2041
 */
const isAIConversationSummaryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_AI_CONVERSATION_SUMMARAY_ENABLED ===
  "true";

const isNewColorPaletteEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_COLOR_PALETTE_ENABLED === "true";

/**
 * Filter attribute analysis result feature
 */

const isFilterAttributeAnalysisResultEnabled =
  import.meta.env
    .VITE_FEATURE_FLAG_IS_FILTER_ATTRIBUTE_ANALYSIS_RESULT_ENABLED === "true";

/**
 * Show/hide POI Parameter feature
 * Clean-up: ORB-2410
 */
const isPOIParameterEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_POI_PARAMETER_ENABLED === "true";

/**
 * Filter Group By for H3 Dataset feature
 */
const isGroupByFilterH3DatasetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GROUP_BY_FILTER_H3_DATASET_ENABLED ===
  "true";

/**
 * Show/hide NPS Modal feature
 * Clean-up: TBD
 */
const isNpsModalEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NPS_MODAL_ENABLED === "true";

/**
 * Show/hide TimeSeries Chart feature
 */
const isTimeSeriesChartEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TIMESERIES_CHART_ENABLED === "true";

/**
 * Show/hide Dataset Recommendation AI feature
 * Clean-up: TBD
 */
const isDatasetRecommendationAIEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_DATASET_RECOMMENDATION_AI_ENABLED ===
  "true";

/**
 * Show/hide GeoJSON Upload feature
 * Clean-up: TBD
 */
const isGeoJsonUploadEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GEOJSON_UPLOAD_ENABLED === "true";

/**
 * Show/hide Show Feature Override Admin Area Data Set in Attribute Filter
 * Clean-up: TBD
 */
const isGlobalFilterOverrideEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GLOBAL_FILTER_OVERRIDE_ENABLED ===
  "true";

/**
 * Show/hide GeoJSON Download feature
 * Clean-up: TBD
 */
const isGeoJsonDownloadEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GEOJSON_DOWNLOAD_ENABLED === "true";

const isFeedbackCtaEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_FEEDBACK_CTA_ENABLED === "true";

/**
 * Show/hide Shapefile Upload feature
 * Clean-up: TBD
 */
const isShapefileUploadEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_SHAPEFILE_UPLOAD_ENABLED === "true";
/**
 * Show/hide Dataset Widget feature
 * Clean-up: TBD
 */
const isDatasetWidgetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_DATASET_WIDGET_ENABLED === "true";

/**
 * Show/hide BVT Data for Catchment feature
 * Clean-up: TBD
 */
const isBVTDataForCatchmentEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_BVT_DATA_FOR_CATCHMENT_ENABLED ===
  "true";

/**
 * Show/hide In-App Onboarding (Product Overview) module
 * Clean-up: TBD
 */
const isOnboardingModuleEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ONBOARDING_MODULE_ENABLED === "true";

/**
 * Show/hide: Coverage Type Feature
 * Clean-up: TBD
 */
const isCoverageTypeEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_COVERAGE_TYPE_ENABLED === "true";

const isCustomMapVisualizationLegendEnabled =
  import.meta.env
    .VITE_FEATURE_FLAG_IS_CUSTOM_MAP_VISUALIZATION_LEGEND_ENABLED === "true";

const isParameterPOIForCatchmentEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_POI_PARAM_FOR_CATCHMENT_ENABLED ===
  "true";

const isKMLUploadEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_KML_UPLOAD_ENABLED === "true";
/**
 * Enable ADM Area filter for My Organization (user) datasets
 */
const isAdminAreaFilterForUserDataEnabled =
  import.meta.env
    .VITE_FEATURE_FLAG_IS_ADMIN_AREA_FILTER_FOR_USER_DATA_ENABLED === "true";
/**
 * Show/hide Dasimetry feature
 * Clean-up: TBD
 */
const isDasimetryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_DASIMETRY_ENABLED === "true";

/**
 * Show/hide Product Switcher (LI ↔ Targetin)
 * Clean-up: TBD
 */
const isProductSwitcherEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_PRODUCT_SWITCHER_ENABLED === "true";
/**
 * New Estimate Grid Catchment
 * Clean-up: TBD
 */
const isNewCatchmentEstimationGrid =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_CATCHMENT_ESTIMATION_GRID === "true";

/**
 * Use the new Road Exclusion list (replaces "Cycling Path" with "Motorway").
 * When off, the original list including "Cycling Path" is shown.
 * Clean-up: TBD
 */
const isNewRoadExclusionEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_ROAD_EXCLUSION_ENABLED === "true";

/**
 * Per-tab isolated state (single IndexedDB, per-tab key namespace); login stays
 * shared. Off = keys not namespaced, behaves like the pre-feature app.
 */
const isOpenTabsOtherEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_OPEN_TABS_OTHER_ENABLED === "true";
/**
 * Show/hide the Targetin data integration in Dataset Management: the Add
 * Dataset source picker, "Import from Targetin", and the per-dataset import
 * status (loading/success/failed) with its Cancel/Retry actions and toasts.
 * Clean-up: TBD
 */
const isTargetinIntegrationEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TARGETIN_INTEGRATION_ENABLED === "true";

/**
 * Keep the Analysis Config panel visible (read-only) beside the Analysis Result
 * panel, so the user can still see which configuration produced the result.
 * Clean-up: ORB-3376
 */
const isAnalysisConfigViewOnlyEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_CONFIG_VIEW_ONLY_ENABLED ===
  "true";

/**
 * Agentic AI: a standalone conversational page for free-form questions about
 * locations, markets, competitors and datasets. Adds the sidebar entry and the
 * /agentic-ai route.
 * Clean-up: TBD
 */
const isAgenticAIEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_AGENTIC_AI_ENABLED === "true";

/**
 * Show/hide the AI Analyst link on the Analysis History page: the sparkle icon
 * marking an analysis as AI-generated, and the Chat section in the detail panel
 * that leads back to the conversation that produced it.
 * Clean-up: TBD
 */
const isAnalysisChatLinkEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_CHAT_LINK_ENABLED === "true";
/**
 * Enable LOKASI internal SSO (OAuth 2.0 + PKCE against the LOKASI IdP).
 * Clean-up: TBD
 */
const isLokasiSsoAuthEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_LOKASI_SSO_AUTH_ENABLED === "true";

/**
 * Save Analysis Result as dataset through the async v2 endpoint, polling the
 * operation status until it settles. Off = synchronous v1 endpoint.
 * Clean-up: TBD
 */
const isV2SaveDatasetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_V2_SAVE_DATASET_ENABLED === "true";

/**
 * Show/hide the "center the map on my location" control, which reads the
 * device GPS position via the browser Geolocation API.
 * Clean-up: TBD
 */
const isUserGeolocationEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_USER_GEOLOCATION_ENABLED === "true";

/**
 * Show/hide ADM Area Mapping on user datasets, where the user maps a column of
 * area codes onto ADM Areas. Separate from `isAdminAreaFilterForUserDataEnabled`,
 * which only gates filtering by an ADM Area that is already mapped.
 * Clean-up: ORB-3586
 */
const isAdmAreaForUserDataEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ADMAREA_FOR_USERDATA_ENABLED === "true";

/**
 * Show/hide Time Series configuration on user datasets, and the timeline
 * ordering driven by the time format picked there.
 * Clean-up: TBD
 */
const isUserDataTimeseriesEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_USER_DATA_TIMESERIES_ENABLED === "true";

const appFeatures = {
  isTemplateEnabled,
  isDrawPolygonEnabled,
  isUseNewDatasetExplorerModal,
  isAnalysisJobListEnabled,
  isPOIInfoEnabled,
  isLoginWithSsoEnabled,
  isNewUIDatasetConfigEnabled,
  isRankingLabelEnabled,
  isRefactorAddDatasetEnabled,
  isMultipleSearchTableDataset,
  isAttributeWeightToggleEnabled,
  isPoiNumericAttributesEnabled,
  isAdvanceDataWeightOptionsEnabled,
  isRowDatasetManagementEnabled,
  isGlobalFilterEnabled,
  isAdminTreeEnabled,
  isAnalysisHistoryEnabled,
  isAISummaryEnabled,
  isLinestringEnabled,
  isTabularViewAnalysisResultEnabled,
  isAIConversationSummaryEnabled,
  isNewColorPaletteEnabled,
  isFilterAttributeAnalysisResultEnabled,
  isPOIParameterEnabled,
  isGroupByFilterH3DatasetEnabled,
  isNpsModalEnabled,
  isTimeSeriesChartEnabled,
  isDatasetRecommendationAIEnabled,
  isGeoJsonUploadEnabled,
  isGlobalFilterOverrideEnabled,
  isGeoJsonDownloadEnabled,
  isFeedbackCtaEnabled,
  isShapefileUploadEnabled,
  isDatasetWidgetEnabled,
  isBVTDataForCatchmentEnabled,
  isOnboardingModuleEnabled,
  isCoverageTypeEnabled,
  isCustomMapVisualizationLegendEnabled,
  isParameterPOIForCatchmentEnabled,
  isKMLUploadEnabled,
  isAdminAreaFilterForUserDataEnabled,
  isDasimetryEnabled,
  isProductSwitcherEnabled,
  isNewCatchmentEstimationGrid,
  isNewRoadExclusionEnabled,
  isTargetinIntegrationEnabled,
  isAnalysisConfigViewOnlyEnabled,
  isAgenticAIEnabled,
  isAnalysisChatLinkEnabled,
  isOpenTabsOtherEnabled,
  isLokasiSsoAuthEnabled,
  isV2SaveDatasetEnabled,
  isUserGeolocationEnabled,
  isAdmAreaForUserDataEnabled,
  isMultipleUserGroupAssignmentEnabled,
  isGranularRbacEnabled,
  isUserDataTimeseriesEnabled
};

export default appFeatures;
